import { memo } from 'react';
import { WEBSITE_PUBLIC_CDN } from 'util/constants';
import Video from '@src/components/ui-kit/video/Video';
import { Flex } from 'antd';

function AnimatedSplashScreen() {
  return (
    <Flex data-cy='animated-splash-screen' vertical>
      <Video
        src={`${WEBSITE_PUBLIC_CDN}/gaming-page-video.webm`}
        title='The Evolution of Gaming'
      />
    </Flex>
  );
}

export default memo(AnimatedSplashScreen);
